/* eslint-disable no-lone-blocks */
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {toast} from 'react-toastify'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
const initialState = {
  updateProfileDetails: {},
}
const API_URL = ENV().REACT_APP_API_URL

export const fetchAsyncupdateProfileDetails: any = createAsyncThunk(
  'updateProfileDetails/fetchAsyncupdateProfileDetails',
  async (data) => {
    const response = await axios.put(`${API_URL}user/me`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response.data
  }
)

const UpdateProfileSlice = createSlice({
  name: 'updateProfileDetails',
  initialState,
  reducers: {
    updateProfileData: (state) => {
      return {...state, updateProfileDetails: {}}
    },
  },
  extraReducers: {
    [fetchAsyncupdateProfileDetails.pending]: (state) => {},
    [fetchAsyncupdateProfileDetails.fulfilled]: (state, {payload}) => {
      {
        payload.success ? toast.success(payload.message) : toast.error(payload.message)
      }
      return {...state, updateProfileDetails: payload}
    },
    [fetchAsyncupdateProfileDetails.rejected]: () => {},
  },
})

export const updateProfileDetailsDate = (state: any) =>
  state.updateProfileDetails.updateProfileDetails

export const {updateProfileData} = UpdateProfileSlice.actions

export default UpdateProfileSlice.reducer
